import {Component, OnInit} from '@angular/core';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {ReferentialService} from '../../../shared/services/referential/referential.service';
import {DeviceService} from '../../../shared/services/device/device.service';
import saveAs from 'file-saver';
import {DeviceType} from '../../../shared/classes/referential/device-type';
import {ModalService} from '../../../shared/services/modal/modal.service';

@Component({
  selector: 'app-device-batch-import',
  templateUrl: './device-batch-import.component.html',
  styleUrls: ['./device-batch-import.component.css']
})
export class DeviceBatchImportComponent implements OnInit {

  faPlus = faPlus;
  deviceTypes: DeviceType[];
  isLoading: boolean;
  noTemplateAvailable: boolean;
  private deviceTypesWithoutBatchImport = ['v3', 'gateway', 'v_sensor', 'g_sensor', 'exteg', 'expe'];

  constructor(private modalService: ModalService,
              private referentialService: ReferentialService,
              private deviceService: DeviceService) {}

  ngOnInit() {
    this.referentialService.getDeviceTypes().subscribe(
        (res: any[]) => {
          if (!(res instanceof Array) || res.length === 0) {
            this.noTemplateAvailable = true;
            return;
          }
          this.deviceTypes = res.filter(
              (type: DeviceType) => !this.deviceTypesWithoutBatchImport.find(
                  (typeFragment) => type.type.includes(typeFragment)
              )
          );
          this.deviceTypes = this.deviceTypes .filter(dts => dts.id < 1000);
        }
    );
  }

  open(modal) {
    this.modalService.openNgbModal(modal, {size: 'lg'});
  }

  getBatchTemplate(deviceType: string) {
    this.deviceService.getDeviceBatchImportTemplate(deviceType).subscribe(
        (res: any) => {
          const blob = new Blob([res], {type: 'text/csv'});
          saveAs(blob, 'template_' + deviceType + '.csv');
        }
    );
  }

}
